<template>
  <div id="faq">
    <v-container v-if="FAQList.length == 0" class="text-center">
        <img src="static/NoBlogs.jpg" class="noItemsTemplate">
        <h4 class="pf-text-green"><b>No FAQ Found !! </b></h4>
    </v-container>
    <v-container fluid class="pt-0 pl-0" v-if="FAQList.length > 0">
      <v-container class="-border" v-for="(eachItem, key) of FAQList" :key="eachItem.id">
        <v-layout>
          <v-flex class="xs12 sm10">
            <h5 class="pf-sub-head mb-2 custom-title">
              <b>{{ (key + 1) + '. ' + eachItem.title }}</b>
            </h5>
            <i>Category: {{ eachItem.category }} </i>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex v-html="eachItem.description" class="text-xs-justify pt-3"></v-flex>
        </v-layout>
        <v-divider class="mt-4"></v-divider>
      </v-container>
    </v-container>
  </div>
</template>

<script>
/* global session store */
import swal from 'sweetalert2';
import { getCollection, update, remove, sortList, formatDate, updateSortList } from '../../helpers/helpers';
import { mapGetters } from 'vuex';
import draggable from 'vuedraggable';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { quillEditor } from 'vue-quill-editor';

// This lists the FAQ items to the agency and family
export default {
  name: 'ListFAQ',
  components: {
    draggable,
    quillEditor,
  },
  data: () => ({
    entity: 'Faq'
  }),
  beforeRouteEnter (to, from, next) {
    if (!session.isOnline()) {
      next({ path: '/login' });
    } else {
      next();
    }
  },
  computed: {
    ...mapGetters(['Account']),
    FAQList: {
      get () {
        return store.state.Faq;
      },
      set (value) {
        store.commit('setFaq', value);
      }
    }
  },
  created () {
    this.initialize();
  },
  methods: {
    // @vuese
    // Used to fetch the FAQ list if not already exists
    async initialize () {
      if (!this.FAQList.length) {
        if (typeof this.Account.membership !== 'undefined') {
          let where = { membership: this.Account.membership };
          let sort = { 'createdAt': -1 };
          let { error, data } = await getCollection(this.entity, true, 0, '', where, null, null, sort);
          if (error) {
            console.log(error);
          } else {
            if (data.length > 0) {
              this.FAQList = data;
            }
          }
        }
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/FAQ/list.vue